import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LoaderBtn from '@components/LoaderBtn/loaderBtn';
import NotFoundPages from '@components/NotFoundPages/notFoundPages';

import { searchTimeOut } from '@constants/general.const';

import JobTitleNotFound from '@images/jobTitle-not-found.svg';

import JobTitlePopupStep5 from '@app/CreateOrganization/step5/jobTitlePopupStep5';
import OrganizationTabHeader from '@app/CreateOrganization/Organizations/organizationTabHeader';
import {
    JobTitleDeleteById,
    getJobTitleData,
} from '@app/CreateOrganization/step5/step5.const';
import StepBadgeComponent from '@app/CreateOrganization/StepBadgeComponent/StepBadgeComponent';

const JobTitleList = ({ organizationId }: any) => {
    const dispatch = useDispatch<any>();

    const { jobTitleStep5Data } = useSelector((state: any) => state);
    const { isDeleteJobTitle, isGetJobTitleDataList } = jobTitleStep5Data;

    const [showPopup, setShowPopup] = useState<boolean>(false);
    const [dataList, setDataList] = useState<Array<any> | null>(null);
    const [search, setSearch] = useState<string | null>();

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        if (search || search === '') {
            const getDataSearch: any = setTimeout(() => {
                getData();
            }, searchTimeOut);
            return () => clearTimeout(getDataSearch);
        }
    }, [search]);

    const getData = async () => {
        getJobTitleData(
            dispatch,
            { nanoId: organizationId, searchText: search },
            setDataList,
        );
    };

    const deleteById = async (officeId: string) => {
        JobTitleDeleteById(officeId, dispatch, getData);
    };

    const handleClose = () => setShowPopup(false);
    const handleShow = () => setShowPopup(true);

    return (
        <>
            <OrganizationTabHeader
                title={'Job Title List'}
                search={search}
                setSearch={setSearch}
                handleShow={handleShow}
                buttonText={'Add New JobTitle'}
            />
            <div className="d-flex flex-wrap gap-2">
                {isDeleteJobTitle || isGetJobTitleDataList ? (
                    <LoaderBtn />
                ) : (
                    dataList &&
                    dataList.length > 0 && (
                        <StepBadgeComponent
                            dataList={dataList}
                            deleteById={deleteById}
                            name={'job_title'}
                            nanoId={'job_nano_id'}
                            handleViewShow={false}
                            className="mnfw__badge_light lh-base text-dark py-2 fs-6 fw-semibold d-flex align-align-items-center bg-white border-opacity-25"
                        />
                    )
                )}
            </div>
            <NotFoundPages
                currentPageData={dataList}
                image={JobTitleNotFound}
                message={`Lorem Ipsum`}
            />
            <JobTitlePopupStep5
                show={showPopup}
                getData={getData}
                handleClose={handleClose}
                organizationId={organizationId}
            />
        </>
    );
};

export default JobTitleList;
